var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":_vm.logoLink}},[_c('acv-logo',{attrs:{"alt":"ACV user management app logo","title":"ACV user management app"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }